module.exports = {
      id: "logos:seekvolunteer-inverse-usage",
      viewBox: "0 0 249 48",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#logos:seekvolunteer-inverse-usage",
      toString: function () {
        return this.url;
      }
    }